export const namespace = 'zipcodeQuestion';